import React from "react";
import { useTranslation } from "react-i18next";
import { ShieldCheck, CreditCard, Languages, Clock, BadgeCheck, FileText } from "lucide-react";

const TrustSection = () => {
  const { t } = useTranslation();

  const stats = ["stat1", "stat2", "stat3", "stat4"];
  const feats = [
    { icon: BadgeCheck, key: "feat1" },
    { icon: ShieldCheck, key: "feat2" },
    { icon: CreditCard, key: "feat4" },
    { icon: Languages, key: "feat5" },
    { icon: Clock, key: "feat6" },
    { icon: FileText, key: "feat3" },
  ];

  return (
    <section data-testid="trust-section" className="py-14 md:py-20 relative">
      <div className="container mx-auto px-6 lg:px-12">
        {/* Compact stats strip */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-5 mb-8 max-w-5xl mx-auto">
          {stats.map((s, i) => (
            <div key={i} className="text-center px-3 py-4 rounded-xl bg-[#0F1115] border border-white/5">
              <div className="font-mono-price text-2xl md:text-3xl text-[#D4AF37] leading-none">
                {t(`trust.${s}.num`)}
              </div>
              <div className="text-[10px] uppercase tracking-wider text-white/50 mt-1.5">{t(`trust.${s}.label`)}</div>
            </div>
          ))}
        </div>

        {/* Features — pill row, ultra compact */}
        <div className="flex flex-wrap justify-center gap-2 max-w-4xl mx-auto">
          {feats.map((f, i) => (
            <div key={i} className="inline-flex items-center gap-2 px-3.5 py-2 rounded-full bg-[#0F1115] border border-white/8 text-xs text-white/70">
              <f.icon size={13} strokeWidth={1.8} className="text-[#D4AF37] shrink-0" />
              <span>{t(`trust.${f.key}`)}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustSection;
